<template>
  <div class="delivery-rules">
    <div v-html="getLocaleValue(exhibition, 'car_pass_entry')"></div>

    <p class="delivery-rules_download">
      {{ $t("event.passes.car.downloadRules") }}
    </p>
    <LinkIcon
      icon="doc"
      bold
      grey
      :href="
        exhibition.website +
          getLocaleValue(exhibition, 'car_pass_entry_procedure')
      "
      target="_blank"
    >
      {{ $t("event.passes.car.entryRules") }}
    </LinkIcon>

    <LinkIcon
      icon="doc"
      bold
      grey
      :href="exhibition.website + getLocaleValue(exhibition, 'car_pass_rule')"
      target="_blank"
    >
      {{ $t("event.passes.car.locationRules") }}
    </LinkIcon>
    <LinkIcon
      v-if="getLocaleValue(exhibition, 'car_pass_terms').length"
      icon="doc"
      bold
      grey
      :href="exhibition.website + getLocaleValue(exhibition, 'car_pass_terms')"
      target="_blank"
    >
      {{ $t("event.passes.car.appForms") }}
    </LinkIcon>
  </div>
</template>

<script>
import { LinkIcon } from "@v2/shared/ui/components";
import { i18n } from "@v2/shared/config";
import { mapGetters } from "vuex";
import { getLocaleValue } from "@/helpers/common";

export default {
  components: {
    LinkIcon
  },
  methods: {
    getLocaleValue
  },
  computed: {
    ...mapGetters("event", ["exhibition"]),
    locale() {
      return i18n.locale;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@v2/app/styles/mixins";

.delivery-rules {
  @include description();

  table {
    width: 100%;
    border-spacing: 0;
    border-collapse: collapse;

    th {
      text-align: left;
    }
  }
  &_download {
    padding: 10px 0;
    margin: 0;
  }
}
</style>
